import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const assignTeamMember = ({
  churchId,
  teamId,
  memberId,
  memberData
}) => {
  return axios.patch(
    `/churches/${churchId}/teams/${teamId}/members/${memberId}`,
    memberData
  );
};

export const useAssignTeamMember = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: data => {
      if (!data?.status) {
        setNotification({
          type: "error",
          message: data?.message || "Could not reassign team member."
        });
        return;
      }
      queryClient.invalidateQueries("team_members");
      setNotification({
        type: "success",
        message: "Team member assigned successfully!"
      });
    },
    ...config,
    mutationFn: assignTeamMember
  });
};
